export default "__VITE_ASSET__BAnz9aet__"